export const HOST_IP = '192.168.2.248'
export const HOST_URL = process.env.NODE_ENV === 'development' ? `http://${HOST_IP}:4555/` : '/'

export const WSSERVER_URL = process.env.NODE_ENV === 'development' ? `ws://${HOST_IP}:4556/` : `wss://${window.location.hostname}:4556/`

export const IsDevIpAddress = (ipAddress: string) => {
    const address = ipAddress.replace('::ffff:', '')
    return address.startsWith('192.168.') || address.startsWith('10.') || address.startsWith('172.16.') || address === '149.106.239.153'
}
